import { render, staticRenderFns } from "./arvioinnin-tyokalut-card.vue?vue&type=template&id=ca5b00a2&scoped=true&"
import script from "./arvioinnin-tyokalut-card.vue?vue&type=script&lang=ts&"
export * from "./arvioinnin-tyokalut-card.vue?vue&type=script&lang=ts&"
import style0 from "./arvioinnin-tyokalut-card.vue?vue&type=style&index=0&id=ca5b00a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca5b00a2",
  null
  
)

export default component.exports